module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_maedori@3x-12a5b15725ea3212bb33d89eeaec0db5.webp";